import type { CreateClientConfig } from "@hey-api/client-axios";
import axios from "axios";
import { showGlobalNotification } from "@/components/NotificationContext";

const instance = axios.create({ withCredentials: true });

instance.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.set("token", token);
    }
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const msg =
      error?.response?.data?.message || error?.message || "网络请求失败";
    showGlobalNotification(msg, { type: "error" });
    return Promise.reject(error);
  },
);

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://www.downcats.com"
      : // : "https://www.downcats.com",
        "http://localhost:5080",
  axios: instance as typeof axios,
});
